var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<toolbar-action disabilita=\"tac.disabilita\" ng-repeat=\"ac in [tac.act1, tac.act2]\" ng-if=\"ac.disabilita()\" azione=\"ac.azione\" icona=\"ac.icona\" descrizione=\"ac.descrizione\" combokey=\"ac.combokey\" identificativo=\"ac.identificativo\">\n</toolbar-action>\n";
var id1="toggleaction.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;